// extracted by mini-css-extract-plugin
export var column = "_s2-0";
export var divider = "_s2-2";
export var timePicker = "_s2-1";